import axios from 'axios';

import type { TUpdateLocalPosts, TLocalPostsEntity } from '../../types/TBatchGoogleModules';

export const updateLocalPosts = async ({
  isUpdating,
  localPostsId,
  localPostsStatus,
  userAccessToken,
  user_id,
  user_name,
  user_email,
}: TUpdateLocalPosts): Promise<TLocalPostsEntity | null> => {
  try {
    if (isUpdating) isUpdating(true);

    const apiPath = `
    ${process.env.REACT_APP_SAAS_BATCH_GOOGLE_MODULES}/local-posts/${localPostsId}`;

    const requestOptions = {
      headers: {
        Authorization: `Bearer ${userAccessToken}`,
      },
    };

    const { data } = await axios.put(
      apiPath,
      {
        status: localPostsStatus,
        user_id,
        user_name,
        user_email,
      },
      requestOptions,
    );

    return data;
  } catch (err) {
    return null;
  } finally {
    if (isUpdating) isUpdating(false);
  }
};
